import { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useGuruContext } from './useGuruContext'
import { selectGuruOverrideScope } from 'ducks/guruWidget/selectors'
import { setOverrideScope, clearOverrideScope } from 'ducks/guruWidget/actions'

const FALLBACK_SCOPE = {
  contextType: 'user',
  contextId: null,
  contextLabel: null,
  subSurface: null,
  entityType: null,
  entityId: null,
}

const buildEffective = (override, route) => {
  if (override) {
    return {
      ...FALLBACK_SCOPE,
      contextType: override.contextType,
      contextId: override.contextId,
      contextLabel: override.contextLabel || null,
    }
  }
  if (route && route.contextType) return route
  return FALLBACK_SCOPE
}

export function useGuruScope() {
  const dispatch = useDispatch()
  const routeScope = useGuruContext()
  const override = useSelector(selectGuruOverrideScope)

  const lastRouteKeyRef = useRef(null)
  const routeKey = `${routeScope?.contextType || ''}:${routeScope?.contextId || ''}`

  useEffect(() => {
    if (lastRouteKeyRef.current === null) {
      lastRouteKeyRef.current = routeKey
      return
    }
    if (lastRouteKeyRef.current !== routeKey) {
      lastRouteKeyRef.current = routeKey
      if (override) {
        dispatch(clearOverrideScope())
      }
    }
  }, [routeKey, override, dispatch])

  const setScope = useCallback(
    scope => dispatch(setOverrideScope(scope)),
    [dispatch],
  )
  const clearScope = useCallback(() => dispatch(clearOverrideScope()), [dispatch])

  const effective = buildEffective(override, routeScope)

  return {
    scope: effective,
    setScope,
    clearScope,
    isOverridden: !!override,
    routeScope,
  }
}
